import { Box, HStack, Text } from '@chakra-ui/react'

import {
  CHART_BAR_LEGEND_FONT_SIZE,
  CHART_BAR_LEGEND_FONT_WEIGHT,
  CHART_BAR_LEGEND_LINE_HEIGHT,
  CHART_LINE_LEGEND_DOT_R_PX,
  CHART_LINE_LEGEND_DOT_STROKE_PX,
  CHART_LINE_LEGEND_GAP,
  CHART_LINE_LEGEND_LINE_STROKE_PX,
  CHART_LINE_LEGEND_VIEWBOX_H,
  CHART_LINE_LEGEND_VIEWBOX_W,
} from './chart.constants'

export type ChartLineLegendItemProps = {
  color: string
  label: string
}

const cx = CHART_LINE_LEGEND_VIEWBOX_W / 2
const cy = CHART_LINE_LEGEND_VIEWBOX_H / 2

export const ChartLineLegendItem = ({
  color,
  label,
}: ChartLineLegendItemProps) => (
  <HStack alignItems="center" spacing={CHART_LINE_LEGEND_GAP}>
    <Box
      as="span"
      display="inline-flex"
      role="img"
      aria-hidden
      flexShrink={0}
      alignItems="center"
    >
      <svg
        width={CHART_LINE_LEGEND_VIEWBOX_W}
        height={CHART_LINE_LEGEND_VIEWBOX_H}
        viewBox={`0 0 ${CHART_LINE_LEGEND_VIEWBOX_W} ${CHART_LINE_LEGEND_VIEWBOX_H}`}
        style={{ flexShrink: 0, display: 'block' }}
      >
        <line
          x1={0}
          y1={cy}
          x2={CHART_LINE_LEGEND_VIEWBOX_W}
          y2={cy}
          stroke={color}
          strokeWidth={CHART_LINE_LEGEND_LINE_STROKE_PX}
          strokeLinecap="round"
        />
        <circle
          cx={cx}
          cy={cy}
          r={CHART_LINE_LEGEND_DOT_R_PX}
          fill={color}
          stroke="white"
          strokeWidth={CHART_LINE_LEGEND_DOT_STROKE_PX}
        />
      </svg>
    </Box>
    <Text
      as="span"
      color="white"
      fontSize={CHART_BAR_LEGEND_FONT_SIZE}
      fontWeight={CHART_BAR_LEGEND_FONT_WEIGHT}
      lineHeight={CHART_BAR_LEGEND_LINE_HEIGHT}
    >
      {label}
    </Text>
  </HStack>
)
